import React from 'react';
import Joyride, { ACTIONS, STATUS, EVENTS } from 'react-joyride';
import { PAGE_HOME } from '../../constants/pages';

function Tour({
  showTour,
  steps,
  stepIndex,

  setShowTour,
  setTourStep,

  appPage,
  fmOpen,
  setMainPage,
  openFileManager,
  closeFileManager,
}) {
  const handleJoyrideCallback = (data) => {
    const { action, index, status, type } = data;

    if (!showTour || EVENTS.TARGET_NOT_FOUND === type) {
      // Don't update state if tour is not running or if target is missing
      return;
    }

    if (EVENTS.STEP_AFTER === type) {
      const nextStepIndex = index + (action === ACTIONS.PREV ? -1 : 1);
      const nextStep = steps[nextStepIndex];

      if (nextStep) {
        if (nextStep.appPage === 'file') {
          if (!fmOpen) {
            setShowTour(false);
            openFileManager(); // Will resume tour after it does this
            setTimeout(() => {
              window.dispatchEvent(new Event('resize')); // Fix display issue
            }, 300);
          } else {
            setTourStep(nextStepIndex);
          }
        } else {
          if (fmOpen) {
            closeFileManager();
          }
          if (nextStep.appPage !== appPage) {
            setShowTour(false);
            setMainPage(nextStep.appPage); // Will resume tour after it does this
            setTourStep(nextStepIndex);
          } else {
            // Move on to the next step now
            setTourStep(nextStepIndex);
          }
        }
      } else {
        // Reset tour
        setShowTour(false);
        setTourStep(0);

        // This is how we know it was truly the last step...
        // Would be nice to find a better way to do this that doesn't involve hard-coding the last step index.
        if (index === 25) {
          // Go back to the start page if so
          setMainPage(PAGE_HOME);
        }
      }
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      // Reset tour
      setShowTour(false);
      setTourStep(0);
    }
  };

  return (
    <Joyride
      debug={true}
      run={showTour}
      continuous={true}
      steps={steps}
      stepIndex={stepIndex}
      callback={handleJoyrideCallback}
      showSkipButton={true}
      disableScrollParentFix={true}
      styles={{
        options: {
          primaryColor: '#e8683b',
        },
      }}
    />
  );
}

export default Tour;
